import { useLocalStorageState } from 'ahooks';
import { Avatar, Dropdown, Menu } from 'antd';
import React, { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { AdminInfo } from '@/types/type';
import styles from './index.module.less';
import useStore from '@/hooks/use-store';
import microApp from '@micro-zoe/micro-app';
import APIFunction from '@/service';
const CustomAvatar: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [, setToken] = useLocalStorageState<string>(
    `JOY_ADMIN_${import.meta.env.VITE_APP_ENV}_TOKEN`,
    {
      defaultValue: '',
    }
  );
  const [adminInfo, setAdminInfo] = useLocalStorageState<AdminInfo | string>(
    `JOY_ADMIN_${import.meta.env.VITE_APP_ENV}_USER_INFO`,
    {
      defaultValue: '',
    }
  );

  const goToAdminInfo = useCallback(() => {
    navigate('/user-info');
  }, [navigate]);

  const logOut = useCallback(() => {
    APIFunction.logout().finally(() => {
      setToken('');
      setAdminInfo('');
      navigate('/login');
    });
  }, [navigate, setToken, setAdminInfo]);

  const { subAppAvatarFunctions, currentSubAppKey } = useStore();

  const onClickSubAppFunction = useCallback(
    (item) => {
      microApp.setData(currentSubAppKey, { event: 'avatar-function-click', params: { item } });
    },
    [currentSubAppKey]
  );

  const menuItems = useMemo(
    () => [
      {
        label: t('User info.User info'),
        key: 'user-info',
        onClick: goToAdminInfo,
      },
      ...subAppAvatarFunctions.map((item) => ({
        label: typeof item.label === 'function' ? React.createElement(item.label) : item.label,
        key: item.key,
        onClick: () => {
          onClickSubAppFunction(item);
        },
      })),
      {
        label: t('Power'),
        key: 'my-power',
        onClick: () => {
          navigate('/my-power');
        },
      },
      {
        label: t('Logout'),
        key: 'log-out',
        onClick: logOut,
      },
    ],
    [goToAdminInfo, logOut, navigate, onClickSubAppFunction, subAppAvatarFunctions, t]
  );

  return (
    <div className={styles['avatar-container']}>
      <Dropdown menu={{ items: menuItems }} placement="bottom">
        <div style={{ paddingRight: '60px' }}>
          {adminInfo && (adminInfo as AdminInfo).avatar ? (
            <Avatar className={styles.avatar} size="default" src={(adminInfo as AdminInfo).avatar} />
          ) : (
            <Avatar
              className={styles.avatar}
              size="default"
              style={{ color: '#475285', backgroundColor: 'darkgray' }}
            >
              {(adminInfo as AdminInfo).username ? (adminInfo as AdminInfo).username[0] : ''}
            </Avatar>
          )}
          <span style={{ paddingLeft: 18, color: '#000000' }}>{(adminInfo as AdminInfo)?.username}</span>
        </div>
      </Dropdown>
    </div>
  );
};

export default CustomAvatar;
